/*Custom axios που επικοινωνεί με το backend και προσθέτει το token στο header*/

import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function checkAllCookies() {
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        cookies.forEach((cookie, i) => {
        });
    } else {
        console.log("No cookies found!");
    }

    // Check specifically for csrftoken
    const csrftoken = getCookie("csrftoken");
}
// Συνάρτηση για να βρεις την τιμή ένος cookie,δηλαδή το csrftoken
// Χρησιμοποιείται για να βρεις το csrf token και να το προσθέσεις στο header του axios instance
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Αν το cookie ξεκινά με το όνομα που ψάχνουμε (π.χ. csrftoken=)
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                //Παίρνουμε την τιμή του cookie και την αποκωδικοποιούμε για να είναι έτοιμη προς χρήση
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    } else {
        console.log("No cookies found in document");
    }
    return cookieValue;
}

// Δημιουργία axios instance
const axiosInstance = axios.create({
    baseURL: API_BASE_URL, //URL του backend
    withCredentials: true, //επιτρέπει την αποστολή cookies 
    headers: {
        "Content-Type": "application/json" // Ολα τα requests θα στέλνουν json
    }
});

// Interceptor για κάθε request → Προσθέτει token και CSRF token στο header
axiosInstance.interceptors.request.use(
    (config) => {
        //Παίρνουμε το access token από το localStorage
        const token = localStorage.getItem("access");
        if (token && token !== "true") {  // Αν υπάρχει το access token στο localStorage
            // Προσθέτουμε το access token στο header του request
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        // Παίρνουμε το csrf token από τα cookies και το προσθέτουμε στο header του request
        const csrfToken = getCookie("csrftoken");
        if (csrfToken) {
            config.headers["X-CSRFToken"] = csrfToken;
        }

        //Επιστρέφουμε το config για να προχωρήσει το request
        return config;
    },
    (error) => Promise.reject(error) // Αν υπάρχει σφάλμα πριν το request φύγει, το επιστρέφουμε
);

//Interceptor για responses → Χειρίζεται σφάλματα (π.χ. μη έγκυρο token)
axiosInstance.interceptors.response.use(
    (response) => response,// Αν το response είναι επιτυχές, το επιστρέφουμε
    async (error) => {
        const originalRequest = error.config;

        // If it's a 401 error and we haven't tried to refresh the token yet
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshToken = localStorage.getItem("refresh");
                if (!refreshToken) {
                    // Clear all auth data
                    localStorage.removeItem("access");
                    localStorage.removeItem("refresh");
                    localStorage.removeItem("username");
                    // Only redirect to login if not already on login/auth page
                    const currentPath = window.location.pathname;
                    if (!currentPath.startsWith("/auth/")) {
                        window.location.href = "/auth/login";
                    }
                    throw new Error("No refresh token available");
                }

                // Try to refresh the token
                const response = await axios.post(
                    `${API_BASE_URL}/user/token/refresh/`,
                    { refresh: refreshToken },
                    {
                        headers: {
                            "Content-Type": "application/json"
                        },
                        withCredentials: true
                    }
                );


                if (response.data && response.data.access) {
                    const { access } = response.data;
                    localStorage.setItem("access", access);
                    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${access}`;
                    originalRequest.headers["Authorization"] = `Bearer ${access}`;

                    // Retry the original request with the new token
                    return axiosInstance(originalRequest);
                } else {
                    throw new Error("Invalid refresh token response");
                }
            } catch (refreshError) {
                // If refresh fails, clear all auth data
                localStorage.removeItem("access");
                localStorage.removeItem("refresh");
                localStorage.removeItem("username");
                // Only redirect to login if not already on login/auth page
                const currentPath = window.location.pathname;
                if (!currentPath.startsWith("/auth/")) {
                    window.location.href = "/auth/login";
                }
                return Promise.reject(refreshError);
            }
        }

        // If it's a 403 error (Forbidden), try to refresh the token
        if (error.response?.status === 403 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const refreshToken = localStorage.getItem("refresh");
                if (refreshToken) {
                    const response = await axios.post(
                        `${API_BASE_URL}/user/token/refresh/`,
                        { refresh: refreshToken },
                        {
                            headers: {
                                "Content-Type": "application/json"
                            },
                            withCredentials: true
                        }
                    );


                    if (response.data && response.data.access) {
                        const { access } = response.data;
                        localStorage.setItem("access", access);
                        axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${access}`;
                        originalRequest.headers["Authorization"] = `Bearer ${access}`;
                        return axiosInstance(originalRequest);
                    }
                }
            } catch (refreshError) {
                console.error("Token refresh failed:", refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
export { getCookie };